import { fromJS } from 'immutable';

import MediumRecord from 'records/medium';
import baseReducer from 'redux/baseReducer';
import { CREATE_MEDIUM_SUCCESS, UPDATE_MEDIUM_SUCCESS } from 'redux/medium/reducer';
import { createSymbols } from 'utils/helpers';

export const {
    FETCH_MEDIA,
    FETCH_MEDIA_FAIL,
    FETCH_MEDIA_SUCCESS,
    POST_VIDEO_SHORT,
    POST_VIDEO_SHORT_FAIL,
    POST_VIDEO_SHORT_SUCCESS,
} = createSymbols([
    'FETCH_MEDIA',
    'FETCH_MEDIA_FAIL',
    'FETCH_MEDIA_SUCCESS',
    'POST_VIDEO_SHORT',
    'POST_VIDEO_SHORT_FAIL',
    'POST_VIDEO_SHORT_SUCCESS',
]);

const initialState = fromJS({
    hasFetched: false,
    isFetching: false,
    media: [],
});

const createMediumSuccess = (state, { payload }) => {
    const media = state.get('media').push(MediumRecord(payload.data));

    return state.set('media', media);
};
const fetchMedia = (state) => state.set('isFetching', true);
const fetchMediaFail = (state) => state.set('isFetching', false);
const fetchMediaSuccess = (state, { payload }) => state.withMutations((prevState) => {
    prevState.set('hasFetched', true)
        .set('media', fromJS(payload.data.map(MediumRecord)));
});
const updateMediumSuccess = (state, { payload }) => {
    const medium = MediumRecord(payload.data);

    return state.set('media', state.get('media').map((item) => {
        if (item.get('id') === medium.get('id')) {
            return medium;
        }

        return item;
    }));
};

export default baseReducer(initialState, {
    [CREATE_MEDIUM_SUCCESS]: createMediumSuccess,
    [FETCH_MEDIA]: fetchMedia,
    [FETCH_MEDIA_FAIL]: fetchMediaFail,
    [FETCH_MEDIA_SUCCESS]: fetchMediaSuccess,
    [UPDATE_MEDIUM_SUCCESS]: updateMediumSuccess,
});



// WEBPACK FOOTER //
// ./src/redux/media/reducer.js